export default function LoadingMonaco() {
  return <div style={{ height: "74vh" }}> </div>;
}
